import { render } from "./KernwoordenView.vue?vue&type=template&id=ca1d9136"
import script from "./KernwoordenView.vue?vue&type=script&lang=js"
export * from "./KernwoordenView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__